import { Selection, select } from "d3";
import { _SvEscolaridadObtenerConfiguracion } from "../../data/services/Escolaridad";
import { _SvEventoObtenerComentarios } from "../../data/services/Evento";
import _Label, { _HttpMsg } from "../../utils/Labels";
import { LOADING } from "../components/Loading";
import { ShowToast } from "../components/Toast";

export class Base {

    protected mainContainer: Selection<HTMLDivElement, any, any, any>;

    constructor(
        className?: string, removeAll: boolean = false
    ) {
        className = className || "";
        const MAIN_CONT = select<HTMLBodyElement, undefined>("body")//.select("#MAIN")
        if (removeAll) {
            MAIN_CONT.selectAll(":scope>*:not(.notifications, app-bubble-modal)").remove(); // FIXME cada ventana debería remover sus propios elementos
            this.mainContainer = MAIN_CONT.append("div");//Seleccionar todos los elementos y eliminarlos
        } else {
            this.mainContainer = MAIN_CONT.select("." + className.split(' ')[0]);
            if (this.mainContainer.size() == 0) {
                MAIN_CONT.selectAll(":scope>*:not(.notifications, app-bubble-modal)").remove(); // FIXME cada ventana debería remover sus propios elementos
                this.mainContainer = MAIN_CONT.append("div");
            }
        }

        this.mainContainer.attr("class", className);

        this.InitLoadData();

    }

    public OnInit(): void {

    }

    protected EvaluateConfig(idNivel: number, callback: (valid: boolean) => void) {
        _SvEscolaridadObtenerConfiguracion(idNivel, (status, result) => {
            let valid: boolean = true;

            if (status < 1 || result.length == 0) {
                ShowToast(_Label("general.config"), _HttpMsg("escolaridad/ObtenerConfiguracion", status < 1 ? status : -60));
                LOADING.Dismiss();

                valid = false;
            }

            if (callback) callback(valid);
        }, true);
    }

    private InitLoadData() {
        _SvEventoObtenerComentarios();
    }

    public OnDestroy(): void { }

}